import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { actions as sagaActions, PREFIX } from './actions'
import { IGlobalStore } from 'src/types/store'
import { ICustomLabel, IMailAccount, IThread } from './types'

export interface IState {
  communication: TStateCommunications<typeof sagaActions>
  data: {
    userMailAccounts: IMailAccount[]
    partnerMailAccounts: IMailAccount[]

    customLabels: {
      data: ICustomLabel[]
      nextCursor: null | string
    }

    threads: {
      data: IThread[]
      meta: {
        currentPage: number
        lastPage: number | null
      }
    }
    thread: IThread | null
    assignLink: string | null
  }
}

export const initialState: IState = {
  communication: createStateSagaCommunications(sagaActions),
  data: {
    userMailAccounts: [],
    partnerMailAccounts: [],
    customLabels: {
      data: [],
      nextCursor: null,
    },
    threads: {
      data: [],
      meta: {
        currentPage: 1,
        lastPage: null,
      },
    },
    thread: null,
    assignLink: null,
  },
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
